import CustomUspReviews from '@public/icons/usp_2_new.svg';
import React, { SVGProps } from 'react';

type CustomUspReviewsWrapperProps = SVGProps<SVGSVGElement>;
const CustomUspReviewsWrapper: React.FC<CustomUspReviewsWrapperProps> = (props) => {
  return <CustomUspReviews {...props} />;
};

export default CustomUspReviewsWrapper;
